<div class="w-100 bg-grey-200">
  <div>
    <div class="w-100 py-3 d-none d-lg-flex position-relative justify-content-center lazy-leaderboard-container">
      <div class="leagues-list-leaderboard-lg">
        <flo-lazy
          [componentConstructor]="AdComponent"
          [initialProps]="adLeaderboardLarge"
          [detectorHeight]="90"
        >
        </flo-lazy>
      </div>
    </div>
    <div class="ad-skin d-none d-xl-block">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [initialProps]="adSkin"
      ></flo-lazy>
    </div>
  </div>
  <div
    class="w-100 py-3 d-none d-md-flex d-lg-none justify-content-center position-relative lazy-leaderboard-container"
  >
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardSmall"
      [detectorHeight]="90"
    >
    </flo-lazy>
  </div>
  <main class="container container-fluid min-vh-100 px-0 pt-md-2">
    <div class="mt-md-3 row g-0">
      <ng-container *ngIf="layout$ | async as layout">
        <div class="col-12 col-lg-8 mt-md-3 px-3 px-lg-4 border-lg-right">
          <div class="d-flex flex-row justify-content-between align-items-center mx-xl-2">
            <h1 class="h3 mb-0 text-capitalize" data-test="leagues-header">{{ layout.title }}</h1>
          </div>
          <div class="pb-5 pt-2 mx-xl-2 d-flex flex-column">
            <ng-container *ngIf="layout.items?.items.length; else zeroState">
              <ng-container *ngFor="let leagueLink of layout.items.items; let first = first; trackBy: trackById">
                <div class="d-flex flex-row justify-content-between">
                  <!-- TODO: Styling + add icon from BFF -->
                  <flo-link [ngClass]="{ 'border-top': first }" class="py-2 w-100 border-bottom border-grey-300" [link]="leagueLink"></flo-link>
                </div>
              </ng-container>
            </ng-container>
          </div>
            <ng-template #zeroState>
              <div class="text-center pt-5 mt-md-5" data-test="no-results">
                <flo-error></flo-error>
              </div>
            </ng-template>
        </div>
      </ng-container>
      <aside data-test="leagues-rail" class="d-none d-lg-block col-lg-4 px-3 px-xl-4 pt-0">
        <div class="px-xl-2 stick-to-header">
          <div class="d-none d-lg-flex pt-3 justify-content-center lazy-flex-container">
            <flo-lazy
              [componentConstructor]="AdComponent"
              [initialProps]="adSidebarRectangle"
              [detectorHeight]="250"
            ></flo-lazy>
          </div>
        </div>
      </aside>
    </div>
  </main>
  <div class="stick-to-footer d-sm-none">
    <div class="adhesion-ad">
      <flo-lazy
        [componentConstructor]="AdComponent"
        [detectorHeight]="50"
        [initialProps]="adAdhesion"
      ></flo-lazy>
    </div>
  </div>
</div>
